import store from "@/store";

export const GetPagination = ({ pagination }) => pagination;
export const GetRole = ({ role }) => role;
/*
export function GetCan() {
  const permissions = store.getters["auth/getUserPermissions"] || [];
  const isAdmin = store.getters["auth/userIsAdmin"];

  return (permission) => {
    if (!permission) return true;
    if (isAdmin) return true;

    if (typeof permission === "object" && Array.isArray(permission)) {
      const checkPermission = (name) => permission.includes(name);
      const hasPermission = permission.findIndex(checkPermission) > -1;

      return hasPermission;
    }

    const hasPermission = permissions.includes(permission);
    return hasPermission;
  };
}
*/
export const GetCan = () => (permission) => {
  if (!permission) {
    return true;
  }

  let user = store.getters["auth/GetUser"];

  if (
    user &&
    (user.roles.includes("super-admin") ||
      user.permissions.includes(permission))
  ) {
    return true;
  }
  return false;
};
